<template>
  <content-dialog
    :visible.sync="modalVisible"
    fullscreen
    force-close-icon
    card-class="blue-grey lighten-5"
    title-padding="pa-0"
  >
    <template
      v-if="yachtModel"
      slot="dialogTitle"
    >
      <v-row
        v-if="yachtModel"
        no-gutters
        align="center"
      >
        <v-col
          cols="auto"
          class="pb-3"
          style="padding-left: 100px"
        >
          <v-avatar
            color="grey lighten-3"
            size="55px"
          >
            <v-img
              v-if="yachtModel.main_image"
              :src="yachtModel.main_image.path"
              alt="Main image"
            />
          </v-avatar>
        </v-col>
        <v-col class="pl-4 pt-3 fill-height">
          <div>
            {{ yachtModel.full_name }}
            &middot;
            <span class="grey--text">
              ID {{ yachtModel.id }}
            </span>
          </div>
          <v-tabs
            v-model="currentCountryId"
            background-color="transparent"
          >
            <v-tab
              v-for="country in yachtModel.countries"
              :key="country.id"
              :href="'#' + country.id"
              class="text-none caption"
            >
              <flag
                :iso="country.code"
                :squared="false"
                style="font-size: 10px"
                class="mr-1"
              />
              {{ country.name }}
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col
          v-if="hasActions"
          cols="auto"
        >
          <!--          <v-btn-->
          <!--            color="primary"-->
          <!--            class="mr-2"-->
          <!--          >-->
          <!--            Start Sales-->
          <!--          </v-btn>-->
          <v-btn
            color="primary"
            class="mr-3"
            @click="shouldGenerateAnnex = true; configureEquipmentDialog = true"
          >
            Generate Annex
          </v-btn>
          <v-btn
            v-if="$can('create', 'Yacht')"
            color="primary"
            class="mr-6"
            @click="yachtEdit.visible = true"
          >
            Start Sales
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <v-card-text
      v-if="yachtModel"
      class="pa-0"
    >
      <v-row
        class="fill-height"
        no-gutters
        justify="center"
      >
        <v-col
          lg="10"
          class="pl-12 pr-4 pb-12 fill-height"
          style="overflow-y: auto"
        >
          <div class="pa-4 subtitle-1">
            Basic Details
          </div>
          <v-card
            elevation="10"
            color="white"
          >
            <v-card-text>
              <v-row>
                <v-col>
                  <yacht-data-row
                    label="Yacht Model"
                    striped
                  >
                    {{ yachtModel.full_name }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Model Year"
                    striped
                  >
                    {{ yachtModel.model_year }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Yacht Type"
                    striped
                  >
                    {{ yachtModel.type.label }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Guest Cabins"
                    striped
                  >
                    {{ yachtModel.cabin_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Crew Cabins"
                    striped
                  >
                    {{ yachtModel.crew_cabin_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Guest Berths"
                    striped
                  >
                    {{ yachtModel.berth_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Crew Berths"
                    striped
                  >
                    {{ yachtModel.crew_berth_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Engine"
                    striped
                  >
                    {{ yachtModel.engines_description }}
                  </yacht-data-row>
                </v-col>
                <v-col>
                  <yacht-data-row
                    label="Dimensions"
                    striped
                  >
                    LOA {{ yachtModel.length | fromMetric('m', 2) }} &middot; Beam {{ yachtModel.beam | fromMetric('m', 2) }} &middot; Draught {{ yachtModel.draught | fromMetric('m', 2) }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Mast height"
                    striped
                  >
                    {{ yachtModel.mast_height | fromMetric('m', 2) }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Sail area main & furling genoa"
                    striped
                  >
                    {{ yachtModel.main_sail_area | fromMetric('m2', 2) }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Light displacement"
                    striped
                  >
                    {{ yachtModel.displacement | fromMetric('kg', 2) }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Toilletes"
                    striped
                  >
                    {{ yachtModel.toilette_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Steering wheels"
                    striped
                  >
                    {{ yachtModel.steering_wheel_count }}
                  </yacht-data-row>
                  <yacht-data-row
                    label="Fuel tank(s)"
                    striped
                  >
                    {{ yachtModel.fuel_tanks_description }} l
                  </yacht-data-row>
                  <yacht-data-row
                    label="Water tank(s)"
                    striped
                  >
                    {{ yachtModel.water_tanks_description }} l
                  </yacht-data-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-row
            no-gutters
            class="mt-4 pa-4"
          >
            <v-col>
              <div class="subtitle-1">
                Equipment
              </div>
            </v-col>
            <v-col cols="auto">
              <v-btn-toggle
                v-model="currentEquipmentType"
                color="primary"
                background-color="transparent"
                borderless
                mandatory
              >
                <v-btn
                  small
                  value="all"
                >
                  All
                </v-btn>
                <v-btn
                  small
                  value="shipyard"
                >
                  Yard Equipment
                </v-btn>
                <v-btn
                  small
                  value="navigare"
                >
                  Navigare Equipment
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col
              v-for="pack in equipmentPacksByCountry"
              :key="pack.id"
              cols="16"
            >
              <v-card
                elevation="10"
                class="fill-height"
                :style="{ borderTop: '2px solid ' + pack.category.color }"
              >
                <v-card-title
                  class="body-2 px-4 py-2 no-gutters clickable"
                  @click="pack.is_expanded = !pack.is_expanded"
                >
                  <v-col>
                    {{ pack.category.name }}
                    &middot;
                    {{ pack.public_label }}
                  </v-col>
                  <v-col
                    cols="auto"
                    class="grey--text caption"
                  >
                    {{ pack.code }}
                  </v-col>
                  <v-col
                    cols="auto"
                    class="pl-4"
                  >
                    <v-chip
                      v-if="pack.default"
                      small
                      color="success"
                      dark
                    >
                      Included
                    </v-chip>
                    <span v-else>
                      + {{ pack.sale_price | currency(pack.currency) }}
                    </span>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="pl-4"
                  >
                    <v-icon>
                      {{ pack.is_expanded ? 'expand_less' : 'expand_more' }}
                    </v-icon>
                  </v-col>
                </v-card-title>
                <v-expand-transition>
                  <div v-if="pack.is_expanded">
                    <v-divider />
                    <v-card-text>
                      <div
                        v-for="(item, index) in pack.items"
                        :key="pack.id + '_' + index"
                        class="caption list--striped pa-1"
                      >
                        {{ item.label }}
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!--<editor-fold desc="Price Column">-->
        <v-col
          v-if="yachtModel"
          lg="5"
          class="px-6 fill-height"
          style="overflow-y: auto"
        >
          <div class="pa-4 subtitle-1">
            Yacht Annex Price
          </div>
          <small-pricing-list
            :condensed="true"
            :base-price="yachtModel.sale_price"
            :base-currency="yachtModel.currency"
            :equipment-price="countryData.equipment_sale_price"
            :cdr-cost="countryData.cost_cdr"
            :currency="yachtModel.currency"
            :currency-exchange-year="yachtModel.model_year"
            :total-price="countryData.total_sale_price"
            :model-year="yachtModel.model_year"
            :production-year="yachtModel.model_year"
          />
        </v-col>
        <!--</editor-fold>-->
      </v-row>
    </v-card-text>

    <yacht-model-configure-equipment-dialog
      v-if="yachtModel && parseInt(currentCountryId)"
      :yacht-model-id="yachtModel.id"
      :country-id="parseInt(currentCountryId)"
      :visible.sync="configureEquipmentDialog"
      @configuration="onConfiguration"
    />

    <new-document-dialog
      v-if="yachtModel"
      key="offer_model"
      :content="documentPreview.html"
      :document-type="documentPreview.type"
      :read-only="documentPreview.readOnly"
      :visible.sync="documentPreview.dialog"
      @document:created="documentCreated"
    />

    <yacht-edit-dialog
      v-if="$can('create', 'Yacht') && yachtModelId && countryId"
      :visible.sync="yachtEdit.visible"
      :yacht-model-id="yachtModelId"
      :country-id="countryId"
      @update:yacht="yachtCreated"
    />
  </content-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import YachtEquipmentPack from '@/models/YachtEquipmentPack'
import ContentDialog from '@/components/helpers/Dialog'
import YachtModel from '@/models/YachtModel'
import YachtDataRow from '@/components/business/yachts/details/YachtDataRow'
import SmallPricingList from '@/components/business/yachts/SmallPricingList'
import { sortBy } from 'lodash'
import YachtModelConfigureEquipmentDialog from '@/components/business/yachtModels/YachtModelConfigureEquipmentDialog'
import NewDocumentDialog from '@/components/business/yachts/NewDocumentDialog'
import DocumentTemplate from '@/models/DocumentTemplate'
import Document from '@/models/Document'
import File from '@/models/File'

export default {
    name: 'YachtModelViewDialog',
    components: {
      YachtEditDialog: () => import('@/components/business/yachts/YachtEditDialog'),
      NewDocumentDialog,
      YachtModelConfigureEquipmentDialog,
      SmallPricingList,
      YachtDataRow,
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      yachtModelId: {
        type: Number,
        required: true
      },
      countryId: {
        type: Number,
        default: undefined
      },
      hasActions: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        yachtModel: undefined,
        currentCountryId: null,
        currentCategoryId: null,
        currentEquipmentType: 'all',
        configureEquipmentDialog: false,
        shouldGenerateAnnex: false,
        documentPreview: {
          html: null,
          dialog: false,
          loadingPreview: false,
          submitting: false,
          type: DocumentTemplate.TYPE_CONTRACT,
          readOnly: false,
          selectTypeModal: false
        },
        yachtEdit: {
          visible: false
        }
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      equipmentPacksByCountry() {
        return sortBy(this.yachtModel.equipment_packs, 'category.order').filter(ep => {
          if (!ep.countries.some(c => c.id === parseInt(this.currentCountryId))) return false

          if (this.currentEquipmentType !== 'all') {
            if (this.currentEquipmentType === 'shipyard' && ep.installed_by !== this.currentEquipmentType) return false
            if (this.currentEquipmentType === 'navigare' && ep.installed_by !== YachtEquipmentPack.INSTALLED_BY_NAVIGARE && ep.installed_by !== YachtEquipmentPack.INSTALLED_BY_CONTRACTOR) return false
          }

          return true
        })
      },
      countryData() {
        if (!this.currentCountryId) return {}

        const country = this.yachtModel.countries.find(c => c.id === parseInt(this.currentCountryId))

        return country ? country.pivot : {}
      },
      categories() {
        return this.equipmentPackCategories.data.map(category => {
          return {
            ...category,
            isFiltered: this.currentCategoryId === category.id
          }
        })
      },
      ...mapGetters('settings', ['equipmentPackCategories'])
    },
    watch: {
      modalVisible: function (value) {
        if (!value) return

        this.fetchYachtModel()

        if (this.countryId) this.currentCountryId = this.countryId.toString()
      }
    },
    created() {
      this.installedByData = YachtEquipmentPack.installedByData

      this.fetchYachtModel()

      if (this.countryId) this.currentCountryId = this.countryId.toString()
    },
    methods: {
      async fetchYachtModel() {
        try {
          this.loading = false

          let result = await YachtModel.api.find(this.yachtModelId)

          result.equipment_packs = result.equipment_packs.map(ep => ({ ...ep, is_expanded: ep.installed_by === YachtEquipmentPack.INSTALLED_BY_SHIPYARD }))

          this.yachtModel = result
        } catch (e) {
          this.$store.dispatch('alert', {
            text: 'There was a problem getting the model',
            color: 'error'
          })
          throw e
        } finally {
          this.loading = false
        }
      },
      onConfiguration(data) {
        if (this.shouldGenerateAnnex) {
          this.openDocumentPreview(data.yachtModelId, data.countryId, data.equipmentPacks.map(ep => ep.id), data.currency, data.productionYear)
        }
      },
      async openDocumentPreview(yachtModelId, countryId, equipmentPackIds, currency = null, pricelistYear = null) {
        this.documentPreview.loadingPreview = true

        let data = {
          yacht_model_id: this.yachtModel.id,
          country_id: countryId,
          currency: currency,
          production_year: pricelistYear,
          type: 'offer_model',
          equipment_pack_ids: equipmentPackIds
        }

        try {
          this.documentPreview.html = await Document.api.createPreview(data)
          this.documentPreview.type = 'offer_model'
          this.documentPreview.readOnly = true
          this.documentPreview.dialog = true
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.documentPreview.loadingPreview = false
        }
      },
      async documentCreated(document) {
        this.documentPreview.selectTypeModal = false
        await File.api.openDocument(document.file.id)
      },
      yachtCreated(yacht) {
        this.$router.push({ name: 'yachtDashboard', params: { id: yacht.id } })
      }
    }
  }
</script>
<style lang="stylus">
  .clickable
    &:hover
      background: #eeeeee;
</style>
